import DeleteUser from "./DeleteUser";

export default function ConfirmDeleteUser(props) {

  const { user, users, setUsers } = props;

  return (
    <div>
      {/* <!-- Button to Open the Modal --> */}
      <button
        type="button"
        className="btn btn-danger"
        data-toggle="modal"
        data-target={`#confirmDeleteUserModal${user._id}`}
      >
        Delete
      </button>

      {/* <!-- The Modal --> */}
      <div className="modal" id={`confirmDeleteUserModal${user._id}`}>
        <div className="modal-dialog">
          <div className="modal-content">

            {/* <!-- Modal Header --> */}
            <div className="modal-header">
              <h4 className="modal-title">Confirm</h4>
              <button type="button" className="close" data-dismiss="modal">&times;</button>
            </div>

            {/* <!-- Modal body --> */}
            <div className="font-size-22">
            This user will be definitely deleted

            </div>

            {/* <!-- Modal footer --> */}
            <div className="modal-footer">
              <DeleteUser user={user} users={users} setUsers={setUsers}/>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}
